'use strict';

var multisite = angular.module('gymsystem.multisite', []);

multisite.controller('SitesCtrl', ['$rootScope', '$scope', 'server', 'confirm', '$controller', 'util', function($rootScope, $scope, server, confirm, $controller, util) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/settings/get';
    $scope.postUrl = '/api/settings/change';

    var removeSite = function(site) {
        confirm.show('SITE_REMOVE_CONFIRM_TEXT').then(function() {
            server.post('/api/site/remove', null, {id: site.id}, 'Site removed', 'Failed to remove site');
        });
    };

    var changeSite = function(site) {
        util.showDataDialog({controller: 'SiteDataCtrl', item: site});
    };

    var add = function() {
        util.showDataDialog({controller: 'SiteDataCtrl'});
    };

    $scope.sitesConfig = {
        getItems: function() {
            return $rootScope.sites;
        },
        triggers: ['site'],
        countSuffixList: ['site', 'sites'],
        columns: [
            { field: 'name', title: 'Name', format: 'translated' }
        ],
        rowClick: changeSite,
        orderColumn: 'name',
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: changeSite },
            { title: 'Remove', buttonClass: 'btn-danger', tooltip: 'Remove', onClick: removeSite, visible: () => $rootScope.sites.length > 1 }
        ],
        searchButtons: [
            {title: 'Add', buttonClass: 'btn-success', onClick: add}
        ]
    };

    $scope.fields = [
        {name: 'stockPerSite', title: 'Stock per site', type: 'checkbox' },
        {name: 'limitStaffSiteAccess', title: 'Staff can only see connected sites', type: 'checkbox' }
    ];

    $scope.getSettings();
}]);

multisite.controller('SiteDataCtrl', ['$rootScope', '$scope', 'util', 'server', 'options', function($rootScope, $scope, util, server, options) {
    $scope.config = _.deep_extend(options.config, {
        datatype: 'site',
        url: {
            add: '/api/site/add',
            change: '/api/site/change'
        },
        data: {
            legal_entities: server.get('/api/legal_entity/get/all')
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    { name: 'name', title: 'Name', required: true, type: 'text' },
                    { name: 'address', title: 'Address', required: true, type: 'textarea' },
                    { name: 'zipCode', title: 'Zip code', required: true, type: 'zipCode' },
                    { name: 'city', title: 'City', required: true, type: 'text' },
                    { name: 'mail', title: 'Reply-to email address', type: 'email', helpText: 'If set, this address is used as reply-to on emails to members. Leave blank to use the system global email address.' },
                    { name: 'legal_entity_id', title: 'Legal entity', type: 'select', useId: true, required: true, options: () => $scope.config.data.legal_entities, visible: () => $rootScope.hasModule('MultipleLegalEntities'), readonly: !!options?.item?.legal_entity_id  }
                ]
            }
        ],
        afterInit: function() {
            if (options?.item?.name === 'Main site') {
                $scope.config.control.getField('name').value = util.t('Main site');
            }
        }
    });
}]);

